angular.module('env.custom.customModule.gridItemsActionsHelperService', [])
    .service('gridItemsActionsHelperService', function ($log, $q, toastr, orderItemsRepository, workflowRepository, uiLocalization, gettextCatalog) {

        var _this = this;

        var executeActionOnItems = function (currentStep, actionToExecute, selectedOrderItemIds, setBusyStateFunc) {

            if (!currentStep || !actionToExecute) {
                throw "Current step code and action code have to be defined.";
            }

            setBusyStateFunc(true);

            return workflowRepository.executeActionForOrderItems(currentStep, actionToExecute, selectedOrderItemIds)
                .then(function (resp) {
                    $log.debug('Executed action [' + actionToExecute + '] for selected ' + selectedOrderItemIds.length + ' items.');
                    toastr.info(
                        uiLocalization.translate("%s items has been progressed [%s].", selectedOrderItemIds.length, actionToExecute),
                        uiLocalization.translate("Action execution completed"));
                },
                    function (error) {
                        if (error) {
                            var em = error.serverErrorMessage || error.message;
                            toastr.error(uiLocalization.translate("Action execution error! Error details: %s", em));
                            $log.error("Action execution error: \n" + em);
                        }
                        return $q.reject(null);
                    });
        };

        _this.shipOrdersInGroup = function (gridItemsGroup, currentStep, actionToExecute, setBusyStateFunc, gridReloadFunc, resetOrderItemsGridSharedSettings) {
            try {
                if (!gridItemsGroup || !gridItemsGroup.items) {
                    throw "Group item is undefined. Can not select orders in a group.";
                }

                var kg = $("#orderItemsGrid").data("kendoGrid");
                var items = gridItemsGroup.items;
                var shipItemsConfirm = function (company, ordersCount) {
                    return $("<div></div>").kendoConfirm({
                        title: _.str.sprintf("Ship <b>%s</b> order%s to %s", ordersCount, ordersCount === 1 ? "" : "s", company),
                        minWidth: "600px",
                        width: "40%",
                        content: _.str.sprintf("Are you sure to ship <b>%s</b> order%s to %s as a consolidated package?", ordersCount, ordersCount === 1 ? "" : "s", company)
                    }).data("kendoConfirm").open().result;
                }

                if (items.length > 0) {
                    shipItemsConfirm(items[0].$model.order.$model.deliveryAddress.$model.companyName, items.length)
                        .then(function () {
                            setBusyStateFunc(true);
                            kg.clearSelection();
                            var groupItemsIds = _.map(items, function(i) { return i.$model.id; });

                            return executeActionOnItems(currentStep, actionToExecute, groupItemsIds, setBusyStateFunc)
                                .then(function (result) {
                                    //Now we can reset the selected items, page number and grid
                                    resetOrderItemsGridSharedSettings();
                                    kg.dataSource.page(1);

                                    gridReloadFunc().then(function () { setBusyStateFunc(false); });
                                },
                                function (err) {
                                    setBusyStateFunc(false);
                                    toastr.error('The error has been logged. Please contact OrderManager administrator.', 'Oops, something went wrong :(');
                                    $log.error('Error during setting Freight Ref to orders in the grid.', err);
                                });
                        },
                        function (data) {
                            setBusyStateFunc(false);
                            //user just cancelled the operation
                        });
                } else {
                    toastr.warning('Sorry, no orders found in the group to be selected.', 'No orders to select');
                }
            } catch (e) {
                //Something went wrong 
                toastr.error('The error has been logged. Please contact OrderManager administrator.', 'Oops, something went wrong :(');
                $log.error('Error during setting Freight Ref to orders in the grid.', e);
            }
        };

        _this.setFreightReferenceToOrdersGroupAndProgress = function (gridItemsGroup, currentStep, actionToExecute, setBusyStateFunc, gridReloadFunc, resetOrderItemsGridSharedSettings) {
            try {
                if (!gridItemsGroup || !gridItemsGroup.items) {
                    throw "Group item is undefined. Can not set Freight Ref to orders in a group.";
                }

                var kg = $("#orderItemsGrid").data("kendoGrid");
                var items = gridItemsGroup.items;
                var freightRefPrompt = function (company, ordersCount) {
                    var dialog = $("<div></div>").kendoPrompt({
                        messages: {
                            okText: _.str.sprintf("Send %s order%s to Packaging", ordersCount, ordersCount === 1 ? "" : "s"),
                            cancel: gettextCatalog.getString("Cancel")
                        },
                        title: _.str.sprintf("Package <b>%s</b> order%s to %s", ordersCount, ordersCount === 1 ? "" : "s", company),
                        value: "",
                        minWidth: "600px",
                        width: "40%",
                        content: gettextCatalog.getString('Orders will be sent as a consolidated package.')
                    }).data("kendoPrompt");
                    
                    var input = dialog.wrapper.find("input.k-textbox");
                    var btnOk = dialog.wrapper.find("li.k-button.k-primary");

                    if (btnOk) {
                        btnOk.attr("disabled", true);
                        btnOk.addClass("k-state-disabled");
                    }
                    if (input) {
                        input.attr("placeholder", gettextCatalog.getString('Enter Freight Reference...'));
                        input.keyup(function() {
                            var valueEntered = input.val();
                            if (valueEntered && valueEntered.length > 0) {
                                btnOk.removeAttr("disabled");
                                btnOk.removeClass("k-state-disabled");
                            } else {
                                btnOk.attr("disabled", true);
                                btnOk.addClass("k-state-disabled");
                            }
                        });
                    }

                    return dialog.open().result;
                };

                if (items.length > 0) {
                    freightRefPrompt(items[0].$model.order.$model.deliveryAddress.$model.companyName, items.length)
                        .then(function (enteredValue) { 
                            if (enteredValue && enteredValue.length > 0) {
                                setBusyStateFunc(true);
                                kg.clearSelection();

                                var itemsUpdatePromises = [];

                                _.each(items,
                                    function(gridItem) {
                                        //Select row in the grid and visually indicate item to be updated
                                        kg.select(kg.table.find('tr[data-uid="' + gridItem.uid + '"]'));
                                        //This will update item in the grid visually with new value
                                        gridItem.$model.customFields.FreightRef = enteredValue;
                                        //Then we get model from pool, set new field value to it and save item to the server
                                        itemsUpdatePromises.push(orderItemsRepository.getOrderItem(gridItem.$model.id)
                                            .then(function(itemFromPool) {
                                                itemFromPool.$model.customFields.FreightRef = enteredValue;
                                                return orderItemsRepository.saveOrderItem(itemFromPool)
                                                    .then(function(resp) {
                                                            $log.debug("OrderItem [Id: " +
                                                                resp.$model.id +
                                                                "] saved to server.");
                                                            return resp;
                                                        },
                                                        function(error) {
                                                            if (error) {
                                                                var em = (error.serverErrorMessage &&
                                                                        _.str.startsWith(error.serverErrorMessage,
                                                                            "Can not use EditOrderItem to change step."))
                                                                    ? gettextCatalog.getString(
                                                                        "Item was updated on server. Please, review it before saving any changes.")
                                                                    : error.serverErrorMessage || error.message;
                                                                toastr.error(em,
                                                                    gettextCatalog.getString(
                                                                        "Order item update failed"));
                                                                $log.error(
                                                                    "OrderItem update error prior to Action execution: unable to save OrderItem. \n" +
                                                                    error.message);
                                                            }
                                                            return $q.reject(null);
                                                        });
                                            })
                                        );
                                    });
                                $q.all(itemsUpdatePromises)
                                    .then(function(result) {
                                            //Wait while we get all items updates posted to server with new values we have set
                                            //and then we can safely move items to next step here
                                            var groupItemsIds = _.map(items, function(i) { return i.$model.id; });

                                            return executeActionOnItems(currentStep,
                                                    actionToExecute,
                                                    groupItemsIds,
                                                    setBusyStateFunc)
                                                .then(function(result) {
                                                    //Now we can reset the selected items, page number and grid
                                                    resetOrderItemsGridSharedSettings();
                                                    kg.dataSource.page(1);
                                                    gridReloadFunc().then(function() { setBusyStateFunc(false); });
                                                });
                                        },
                                        function(err) {
                                            setBusyStateFunc(false);
                                            toastr.error(
                                                'The error has been logged. Please contact OrderManager administrator.',
                                                'Oops, something went wrong :(');
                                            $log.error('Error during setting Freight Ref to orders in the grid.', err);
                                        });
                            } else {
                                toastr.error('Freight Reference for the consolidated package can not be empty.', 'Freight Reference');
                            }
                        },
                        function (data) {
                            setBusyStateFunc(false);
                            //user just cancelled the operation
                        });
                } else {
                    toastr.warning('Sorry, no orders found in the group to be updated.', 'No orders to update');
                }
            } catch (e) {
                setBusyStateFunc(false);
                //Something went wrong 
                toastr.error('The error has been logged. Please contact OrderManager administrator.', 'Oops, something went wrong :(');
                $log.error('Error during setting Freight Ref to orders in the grid.', e);
            }
        };

        return _this;
    })
    ;
